/**
 * animation-switcher.js — Carga diferida + conmutador de motor de animaciones.
 *
 * Concentra en UN solo lugar: (1) la carga del motor tras el primer paint (idle)
 * y (2) el switch entre el motor nativo (IntersectionObserver) y GSAP.
 *
 * Switch de motor: comenta un bloque y descomenta el otro. El motor comentado no
 * tiene ningún `import()` que lo referencie, así que esbuild NO genera su chunk
 * (tree-shaking / code-splitting). Por defecto: motor nativo (sin GSAP en el bundle).
 */

/**
 * Ejecuta una tarea cuando el navegador está inactivo (no bloquea el paint).
 * @param {() => void} task
 */
function runWhenIdle (task) {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(task, { timeout: 2000 })
  } else {
    setTimeout(task, 200)
  }
}

/**
 * Failsafe: revela los elementos .anim para que nunca queden invisibles si el
 * motor tarda o falla en cargar.
 */
function revealAnims () {
  document.querySelectorAll('.anim[data-anim]').forEach((el) => {
    el.style.opacity = '1'
  })
}

/**
 * Carga el motor de animaciones en idle, con failsafe de visibilidad.
 * @param {object} deviceData - datos de dispositivo (usados por el motor GSAP)
 */
function loadAnimations (deviceData) {
  const failsafe = setTimeout(revealAnims, 2500)

  runWhenIdle(async () => {
    try {
      // ── Motor B: nativo (IntersectionObserver) — ACTIVO ──
      const { default: animations } = await import('./animations.js')
      animations()
      clearTimeout(failsafe)

      // ── Motor A: GSAP (opcional) ──
      // const { initGSAP, refreshScrollTrigger } = await import('./gsap.js')
      // initGSAP(deviceData)
      // setTimeout(() => refreshScrollTrigger(), 100)
    } catch (err) {
      console.error('Animation engine failed to load:', err)
      clearTimeout(failsafe)
      revealAnims()
    }
  })
}

export default loadAnimations
